import styled from '@mui/system/styled'

export const Wrapper = styled('div')(() => ({
  marginTop: '-8px',
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  width: '100%',
  minWidth: 0,
  boxSizing: 'border-box'
}))

// Ponto focal do cabeçalho: ícone de upgrade em círculo verde ao lado do título.
export const HeaderIcon = styled('span')(({ theme }) => ({
  flexShrink: 0,
  width: 40,
  height: 40,
  borderRadius: 12,
  background: '#EAF6EA',
  border: `1px solid ${theme.palette.primary.main}`,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center'
}))

export const Lead = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: 14,
  lineHeight: 1.5,
  color: theme.palette.neutral[400],
  maxWidth: '60ch'
}))

// Destaque do principal gancho: cobranças grátis todos os meses.
export const FreeBillingsHighlight = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: '14px 16px',
  borderRadius: 12,
  background: '#EAF6EA',
  border: `1px solid ${theme.palette.primary.main}`
}))

export const HighlightIcon = styled('span')(({ theme }) => ({
  flexShrink: 0,
  width: 34,
  height: 34,
  borderRadius: '50%',
  background: theme.palette.primary.main,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center'
}))

// Título e subtítulo correm na mesma linha ("100 cobranças grátis todos os
// meses via boleto e PIX") e só quebram quando não couberem.
export const HighlightText = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'baseline',
  columnGap: 0,
  rowGap: 1,
  minWidth: 0
}))

export const HighlightTitle = styled('span')(() => ({
  fontSize: 15,
  fontWeight: 700,
  lineHeight: 1.3,
  color: '#2E7D32'
}))

// Idêntico ao título: os dois formam uma frase única.
export const HighlightSubtitle = styled('span')(() => ({
  fontSize: 15,
  fontWeight: 700,
  lineHeight: 1.3,
  color: '#2E7D32'
}))

// Prazo da campanha, discreto mas com data em destaque.
export const Deadline = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: 13,
  lineHeight: 1.5,
  color: theme.palette.neutral[300],
  '& strong': {
    color: theme.palette.neutral[400],
    fontWeight: 700
  }
}))

export const Actions = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  width: '100%',
  marginTop: 4
}))

export const CtaButton = styled('a')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  width: '100%',
  boxSizing: 'border-box',
  padding: '13px',
  borderRadius: 8,
  background: '#111',
  color: '#fff',
  border: '1px solid #111',
  fontSize: 14,
  fontWeight: 600,
  textAlign: 'center',
  textDecoration: 'none',
  cursor: 'pointer',
  lineHeight: 1.3,
  transition: 'background 0.15s ease',
  '&:hover': {
    background: '#000'
  }
}))

export const SecondaryButton = styled('a')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  width: '100%',
  boxSizing: 'border-box',
  padding: '13px',
  borderRadius: 8,
  background: '#fff',
  color: theme.palette.neutral[400],
  border: `1px solid ${theme.palette.neutral[100]}`,
  fontSize: 14,
  fontWeight: 600,
  textAlign: 'center',
  textDecoration: 'none',
  cursor: 'pointer',
  lineHeight: 1.3,
  transition: 'border-color 0.15s ease, background 0.15s ease',
  '&:hover': {
    background: '#F4F8F4',
    borderColor: theme.palette.primary.main
  }
}))
